<template>
  <div class="notifications">
    <div v-if="notification" :class="className()">
      <h3>{{ $t(notification.i18nTitle) }}</h3>
      <p v-if="notification.i18nDescription">{{ $t(notification.i18nDescription, notification.i18nParams ?? {}) }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Notification } from './notifications.types';

export default defineComponent({
  name: 'NotificationsComponent',
  data() {
    return {
      notification: null as unknown as Notification
    };
  },
  computed: {
    notifications() {
      return this.$store.state.notifications;
    }
  },
  methods: {
    className() {
      return `alert alert-${this.notification?.type ?? ''}`;
    },
    removeCurrentNotification() {
      if (!this.notification) {
        return;
      }
      setTimeout(() => {
        this.$store.commit('removeNotification', this.notification?.id);
      }, 3000);
    }
  },
  watch: {
    notifications() {
      this.notification = this.notifications[0];
      this.removeCurrentNotification();
    }
  }
});
</script>

<style lang="scss" scoped src="./notifications.component.scss" />
